import { createAction } from '../actions';

export const NOTIFICATION_SHOW_START = 'NOTIFICATION_SHOW_START';

export function showNotification(toast) {
  return createAction(NOTIFICATION_SHOW_START, { toast });
}
